import styled from "@oui/system"

const StyledFocusGuard = styled("div")({
  height: 0,
  left: 1,
  overflow: "hidden",
  position: "fixed",
  top: 1,
  width: 1
})

export default StyledFocusGuard
